var map = {
	"./about-image.png": 153,
	"./add-to-cart.png": 4836,
	"./android-logo.svg": 7056,
	"./background-hero.png": 642,
	"./destination.png": 7089,
	"./feedback.png": 8307,
	"./gunas_logo.png": 9471,
	"./incasi_logo.png": 4970,
	"./migoku-ideas.png": 30,
	"./mission.svg": 7421,
	"./order-ride.png": 1937,
	"./payment-failed-illustration.png": 509,
	"./payment-success-illustration.png": 6784,
	"./people-buying-oil.png": 7841,
	"./showcase-app-1.png": 1921,
	"./showcase-app-2.png": 8466,
	"./showcase-app-3.png": 4793,
	"./transparent-background.png": 7030,
	"./vision.svg": 12,
	"./wave-pattern-2.svg": 9883,
	"./wave-pattern.svg": 8814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;